export default __webpack_public_path__ + "static/media/bonanza-cn.2962e0cc.webp";